module.exports = __webpack_public_path__ + "img/ico_culture_technic.d641bbb6.svg";